import { useWindowWidth } from '@elfsight/widget-utils';
import { useSocialFeedSettings } from '../utils';
import { variations } from './variations';

const MOBILE_WIDTH = 770;

const MOBILE_LAYOUT = 'feed';

export function Popup() {
  const { popupLayout = 'classic' } = useSocialFeedSettings();

  const windowWidth = useWindowWidth();

  if (windowWidth === 0) {
    return null;
  }

  const finalPopupLayout =
    windowWidth > MOBILE_WIDTH ? popupLayout : MOBILE_LAYOUT;
  const Layout = variations[finalPopupLayout];

  return <Layout />;
}
